__turbopack_context__.v({
  "BadgeNumber": "radio-buttons-module__BgH81W__BadgeNumber",
  "RadioButtons": "radio-buttons-module__BgH81W__RadioButtons",
  "Scrollable": "radio-buttons-module__BgH81W__Scrollable",
});
